import { getToken } from 'firebase/app-check'

import { application } from 'state/application'
import { emitSystemNotification } from 'state/system_notification'

import { firebaseAppCheckState } from './state'
import { SIGN_IN_WITH_EMAIL_LOCAL_KEY } from './types'

export const signInPasswordless = async (
	email: string
	// eslint-disable-next-line consistent-return
) => {
	try {
		const appCheckToken = await getToken(firebaseAppCheckState.peek()!)

		if (!appCheckToken.token) {
			throw new Error('App check token is not available')
		}

		const { error } = await application
			.peek()
			.forManagingAccount()
			.sendSignInEmail(email, window.location.origin, appCheckToken.token)

		if (error) {
			emitSystemNotification({
				display: 'dialog',
				variant: 'warning',
				title: 'Network Error',
				message:
					"We're unable to connect to our servers at this time. Please check your internet connection and try again. If the issue persists, contact our support team.",
				acceptText: 'Close'
			})

			return 'Error sending email. Contact support if this persists'
		}
		window.localStorage.setItem(SIGN_IN_WITH_EMAIL_LOCAL_KEY, email)
	} catch (error) {
		console.error(error)

		if (error instanceof Error) {
			const msg =
				error.message ||
				error.toString() ||
				'Unknown error trying to configm sign in link'

			emitSystemNotification({
				display: 'dialog',
				variant: 'error',
				title: 'Error',
				message: msg
			})

			return msg
		}
	}
}
